import React from 'react';
import { Link } from 'react-router-dom';
import { useUser } from '../../_hooks';
import Loading from '../../_components/shared/loading';
import { Header } from '../../_components/shared/header';

function DashboardRdg() {
    const user = useUser();

    return (
        <>
            <Header />
            <div className={"page landing"}>
                {!user ? <Loading /> : (
                    <>
                        <div className={"boxes"}>
                            <Link className={"box text-center"} to={"/rdg/traiter-grille"}>
                                <span className={"fa fa-grip-horizontal bg-icon"}></span>
                                <h3 className={"bleu"}>Traiter une grille</h3>
                            </Link>
                            <Link className={"box text-center"} to={"/rdg/expedier"}>
                                <span className={"fa fa-comment bg-icon"}></span>
                                <h3 className={"bleu"}>Expédier à un fabricant</h3>
                            </Link>
                        </div>
                    </>
                )}
            </div>
        </>
    );
}

export { DashboardRdg };
